import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { DataService } from '../data/data.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../data/data.service";
var VerifyUsService = /** @class */ (function () {
    function VerifyUsService(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.verifyUSURL = 'https://us-street.api.smartystreets.com/street-address?';
        this.verifyINTURL = 'https://international-street.api.smartystreets.com/verify?';
    }
    VerifyUsService.prototype.verifyInternationalAddress = function (addressToBeVerified) {
        var websiteKey = this.dataService.get().propertyConfig.addressValidationAuthKey;
        var url = this.verifyINTURL + "auth-id=" + websiteKey + "&" + this.serialize(addressToBeVerified);
        var usAddressUrl = url + '&geocode=true';
        return this.http.get(usAddressUrl).pipe(tap(function (json) { return json; }));
    };
    VerifyUsService.prototype.verifyAddress = function (addressToBeVerified) {
        var websiteKey = this.dataService.get().propertyConfig.addressValidationAuthKey;
        var url = this.verifyUSURL + "auth-id=" + websiteKey + "&" + this.serialize(addressToBeVerified);
        var usAddressUrl = url + '&candidates=2&geocode=true&match=invalid';
        // const addressQry = 'https://us-street.api.smartystreets.com/street-address?auth-id=31008886784763106&city=Herndon&state=VA&street=2300%20Dulles%20Corner%20Ln&country=US&candidates=2&geocode=true&match=strict';
        return this.http.get(usAddressUrl).pipe(tap(function (json) { return json; }));
    };
    VerifyUsService.prototype.serialize = function (obj, prefix) {
        var str = [];
        var p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + '[' + p + ']' : p;
                var v = obj[p];
                if (v) {
                    str.push(v !== null && typeof v === 'object' ? this.serialize(v, k) : k + '=' + encodeURIComponent(v));
                }
            }
        }
        return str.join('&');
    };
    VerifyUsService.ngInjectableDef = i0.defineInjectable({ factory: function VerifyUsService_Factory() { return new VerifyUsService(i0.inject(i1.HttpClient), i0.inject(i2.DataService)); }, token: VerifyUsService, providedIn: "root" });
    return VerifyUsService;
}());
export { VerifyUsService };
